import { motion } from "framer-motion";

export const PHASES = [
  { id: "upfront", label: "Upfront", full: "Upfront Agreement" },
  { id: "discovery", label: "Discovery", full: "Discovery" },
  { id: "prescription", label: "Prescription", full: "Prescription" },
  { id: "pitch", label: "Pitch", full: "Pitch" },
  { id: "close", label: "Close", full: "Close" },
  { id: "postsell", label: "Post-Sell", full: "Post-Sell" },
];

/**
 * Compact, always-visible phase strip. Manual only — no auto-detection.
 * Sits at the top of the intelligence panel; tap a pill to switch phase.
 *
 * `pulse` prop: id of a phase to highlight as the suggested next step.
 * The pill stays clickable; this is purely visual guidance.
 */
export default function PhaseTracker({ phase, onChange, pulse }) {
  return (
    <nav
      data-testid="phase-tracker"
      aria-label="Call phase"
      className="bg-white border border-slate-200 rounded-xl px-3 py-2 shadow-sm flex items-center gap-1.5 overflow-x-auto sch-scroll"
    >
      <span className="text-[10px] uppercase tracking-widest text-slate-400 font-display font-semibold shrink-0 px-2">
        Phase
      </span>
      {PHASES.map((p, idx) => {
        const active = p.id === phase;
        const isPulsing = !active && pulse === p.id;
        return (
          <button
            key={p.id}
            type="button"
            onClick={() => onChange(p.id)}
            data-testid={`phase-${p.id}`}
            data-active={active ? "true" : "false"}
            data-pulse={isPulsing ? "true" : "false"}
            className={`relative shrink-0 inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition-colors border ${
              active
                ? "bg-slate-900 text-white border-slate-900"
                : isPulsing
                ? "bg-yellow-50 text-yellow-900 border-yellow-300 sch-phase-pulse"
                : "text-slate-600 hover:bg-slate-100 border-transparent"
            }`}
          >
            <span
              className={`inline-flex items-center justify-center h-4 w-4 rounded-full text-[10px] font-mono font-semibold ${
                active
                  ? "bg-white/20 text-white"
                  : isPulsing
                  ? "bg-yellow-200 text-yellow-900"
                  : "bg-slate-200 text-slate-600"
              }`}
            >
              {idx + 1}
            </span>
            {p.label}
            {active && (
              <motion.span
                layoutId="phase-dot"
                className="absolute -bottom-[7px] left-1/2 -translate-x-1/2 h-1 w-1 rounded-full bg-slate-900"
              />
            )}
          </button>
        );
      })}
    </nav>
  );
}
